import classNames from 'classnames';
import { DotColor, TyDot } from './TyDot';

export const TyChipSmall = ({
  isActive = false,
  children,
  dotColor,
}: {
  isActive?: boolean;
  children: React.ReactNode;
  dotColor?: DotColor;
}) => {
  return (
    <div
      className={classNames(
        'p-2',
        'rounded-[30px]',
        'shadow-down-sm',
        'w-fit',
        'flex',
        'flex-row',
        'items-center',
        'gap-1',
        'hover:bg-secondary-50',
        'hover:cursor-pointer',
        'box-border',
        {
          'bg-white': !isActive,
          'border-[1px] border-secondary-900 bg-secondary-50 -m-[1px]':
            isActive,
        }
      )}
    >
      {dotColor != null ? <TyDot dotColor={dotColor} /> : null}
      <span className="text-secondary-500 font-medium text-[12px] leading-4">
        {children}
      </span>
    </div>
  );
};
